// LiveKit's end-to-end encryption runs in this worker. Vite bundles it as its own file, so the
// production build carries it next to the app.
import E2EEWorker from "livekit-client/e2ee-worker?worker";

export function createE2EEWorker(): Worker {
  return new E2EEWorker();
}
